/**
 * serv.ts — Categoría "Servicios" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_serv",
  skuPrefix: "SER",
  categoria: "Servicios",
} as const;

export const cat_serv_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Corte de Cabello Hombre",
    marca: "Barbería Premium",
    origen: "Colombia",
    costo: 8000,
    precio: 25000,
    stock: 999,
    stockMinimo: 0,
    stockMaximo: 999,
    unidad: "servicio",
    ubicacionFisica: "Local",
    proveedor: "Personal interno",
    descripcionLarga:
      "Servicio de corte de cabello masculino clásico o moderno. Incluye lavado y producto styling.",
    especificaciones: [
      { clave: "Duración", valor: "30 min" },
      { clave: "Incluye", valor: "Lavado + styling" },
    ],
    imageKeywords: ["haircut", "barbershop", "mens-hair"],
    color: "bg-slate-900",
    shape: "circle",
    tieneIVA: false,
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Manicure Tradicional",
    marca: "Spa Belleza",
    origen: "Colombia",
    costo: 5000,
    precio: 18000,
    stock: 999,
    stockMinimo: 0,
    stockMaximo: 999,
    unidad: "servicio",
    ubicacionFisica: "Local",
    proveedor: "Personal interno",
    descripcionLarga:
      "Manicure completo: lima, cutícula, masaje, aplicación esmalte tradicional. 45 minutos.",
    especificaciones: [
      { clave: "Duración", valor: "45 min" },
      { clave: "Esmalte", valor: "Tradicional" },
    ],
    imageKeywords: ["manicure", "nail-service", "beauty-salon"],
    color: "bg-pink-400",
    shape: "square",
    tieneIVA: false,
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Lavado de Auto Estándar",
    marca: "AutoWash Pro",
    origen: "Colombia",
    costo: 8500,
    precio: 28000,
    stock: 999,
    stockMinimo: 0,
    stockMaximo: 999,
    unidad: "servicio",
    ubicacionFisica: "Local",
    proveedor: "Personal interno",
    descripcionLarga:
      "Lavado exterior e interior: shampoo, enjuague, aspirado, tablero y llantas. 45 min.",
    especificaciones: [
      { clave: "Duración", valor: "45 min" },
      { clave: "Incluye", valor: "Ext. + int." },
    ],
    imageKeywords: ["car-wash", "auto-service", "car-cleaning"],
    color: "bg-blue-500",
    shape: "square",
    tieneIVA: false,
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Entrenamiento Personal 1h",
    marca: "FitPro Trainer",
    origen: "Colombia",
    costo: 15000,
    precio: 60000,
    stock: 999,
    stockMinimo: 0,
    stockMaximo: 999,
    unidad: "sesión",
    ubicacionFisica: "Local",
    proveedor: "Personal interno",
    descripcionLarga:
      "Sesión personal training 1h con entrenador certificado. Plan individualizado según objetivos.",
    especificaciones: [
      { clave: "Duración", valor: "60 min" },
      { clave: "Entrenador", valor: "Certificado" },
    ],
    imageKeywords: ["personal-trainer", "fitness-coach", "gym-session"],
    color: "bg-green-500",
    shape: "square",
    tieneIVA: false,
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Tinte Cabello Completo",
    marca: "Spa Belleza",
    origen: "Colombia",
    costo: 25000,
    precio: 95000,
    stock: 999,
    stockMinimo: 0,
    stockMaximo: 999,
    unidad: "servicio",
    ubicacionFisica: "Local",
    proveedor: "Personal interno",
    descripcionLarga:
      "Servicio tinte cabello completo incluyendo consulta color, aplicación y secado. Productos Schwarzkopf.",
    especificaciones: [
      { clave: "Duración", valor: "2 horas" },
      { clave: "Productos", valor: "Schwarzkopf" },
    ],
    imageKeywords: ["hair-coloring", "salon-service", "hair-dye"],
    color: "bg-orange-500",
    shape: "square",
    tieneIVA: false,
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Masaje Relajante 60min",
    marca: "Spa Belleza",
    origen: "Colombia",
    costo: 30000,
    precio: 110000,
    stock: 999,
    stockMinimo: 0,
    stockMaximo: 999,
    unidad: "servicio",
    ubicacionFisica: "Local",
    proveedor: "Personal interno",
    descripcionLarga:
      "Masaje relajante cuerpo completo 60min con aceites esenciales. Alivia estrés y tensión muscular.",
    especificaciones: [
      { clave: "Duración", valor: "60 min" },
      { clave: "Incluye", valor: "Aceites esenciales" },
    ],
    imageKeywords: ["massage", "spa-service", "relaxation"],
    color: "bg-purple-400",
    shape: "square",
    tieneIVA: false,
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Arreglo de Barba",
    marca: "Barbería Premium",
    origen: "Colombia",
    costo: 4000,
    precio: 15000,
    stock: 999,
    stockMinimo: 0,
    stockMaximo: 999,
    unidad: "servicio",
    ubicacionFisica: "Local",
    proveedor: "Personal interno",
    descripcionLarga:
      "Perfilado y arreglo de barba con navaja, compresa caliente y aceites. Finalizado con bálsamo.",
    especificaciones: [
      { clave: "Duración", valor: "25 min" },
      { clave: "Técnica", valor: "Navaja clásica" },
    ],
    imageKeywords: ["beard-trim", "barber-service", "mens-grooming"],
    color: "bg-slate-700",
    shape: "square",
    tieneIVA: false,
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Clase Spinning Grupal",
    marca: "FitPro Trainer",
    origen: "Colombia",
    costo: 3500,
    precio: 18000,
    stock: 999,
    stockMinimo: 0,
    stockMaximo: 999,
    unidad: "clase",
    ubicacionFisica: "Local",
    proveedor: "Personal interno",
    descripcionLarga:
      "Clase spinning grupal 45min con música e instructor certificado. Aforo máx 15 personas.",
    especificaciones: [
      { clave: "Duración", valor: "45 min" },
      { clave: "Aforo", valor: "15 personas" },
    ],
    imageKeywords: ["spinning-class", "group-fitness", "cycling"],
    color: "bg-red-500",
    shape: "square",
    tieneIVA: false,
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Polarizado Vidrios Auto",
    marca: "AutoWash Pro",
    origen: "Colombia",
    costo: 85000,
    precio: 195000,
    stock: 999,
    stockMinimo: 0,
    stockMaximo: 999,
    unidad: "servicio",
    ubicacionFisica: "Local",
    proveedor: "Personal interno",
    garantia: "3 años",
    descripcionLarga:
      "Instalación polarizado profesional para auto estándar (4 laterales + trasero). Garantía 3 años.",
    especificaciones: [
      { clave: "Vidrios", valor: "5" },
      { clave: "Grado", valor: "Configurable" },
    ],
    imageKeywords: ["car-tinting", "window-tint", "auto-service"],
    color: "bg-slate-900",
    shape: "square",
    tieneIVA: false,
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Pedicure SPA",
    marca: "Spa Belleza",
    origen: "Colombia",
    costo: 12000,
    precio: 42000,
    stock: 999,
    stockMinimo: 0,
    stockMaximo: 999,
    unidad: "servicio",
    ubicacionFisica: "Local",
    proveedor: "Personal interno",
    descripcionLarga:
      "Pedicure premium: remojo, exfoliación, hidratación, corte uñas y esmalte. 1h 15min.",
    especificaciones: [
      { clave: "Duración", valor: "75 min" },
      { clave: "Incluye", valor: "Exfoliación + masaje" },
    ],
    imageKeywords: ["pedicure", "foot-spa", "nail-care"],
    color: "bg-pink-500",
    shape: "square",
    tieneIVA: false,
  }),
];
